import type { RadioAdCampaign } from '@/pages/sa/radio-advertiser/types';

export const radioAdvertiserCampaigns: RadioAdCampaign[] = [
  {
    id: 1,
    radioName: 'Voz del Pueblo',
    radioFrequency: 'FM 104.5',
    radioCity: 'Buenos Aires',
    radioPlan: 'Premium',
    promotionType: 'radio',
    promotionName: 'Voz del Pueblo FM',
    country: 'Argentina',
    state: 'CABA',
    city: 'Buenos Aires',
    category: 'Música',
    impressions: 245000,
    clicks: 18375,
    ctr: 7.5,
    budget: 800,
    spend: 560,
    costPerClick: 0.03,
    status: 'activa',
    startDate: '05/05/2026',
    endDate: '05/06/2026',
  },
  {
    id: 2,
    radioName: 'Radio Capital',
    radioFrequency: 'FM 96.8',
    radioCity: 'Buenos Aires',
    radioPlan: 'Premium',
    promotionType: 'programa',
    promotionName: 'Despertar Nacional',
    country: 'Argentina',
    state: 'CABA',
    city: 'Buenos Aires',
    category: 'Noticias',
    impressions: 580000,
    clicks: 41180,
    ctr: 7.1,
    budget: 1200,
    spend: 890,
    costPerClick: 0.022,
    status: 'activa',
    startDate: '01/06/2026',
    endDate: '30/06/2026',
  },
  {
    id: 3,
    radioName: 'Estación Latina',
    radioFrequency: 'FM 88.2',
    radioCity: 'Ciudad de México',
    radioPlan: 'Premium',
    promotionType: 'evento',
    promotionName: 'Festival Latina 2026',
    country: 'México',
    state: 'CDMX',
    city: 'Ciudad de México',
    category: 'Eventos',
    impressions: 720000,
    clicks: 61920,
    ctr: 8.6,
    budget: 2000,
    spend: 1650,
    costPerClick: 0.027,
    status: 'activa',
    startDate: '01/05/2026',
    endDate: '15/07/2026',
  },
  {
    id: 4,
    radioName: 'Rock Nacional',
    radioFrequency: 'FM 102.3',
    radioCity: 'Córdoba',
    radioPlan: 'Estándar',
    promotionType: 'concurso',
    promotionName: 'Ganá Entradas RockFest',
    country: 'Argentina',
    state: 'Córdoba',
    city: 'Córdoba',
    category: 'Música',
    impressions: 185000,
    clicks: 13320,
    ctr: 7.2,
    budget: 500,
    spend: 320,
    costPerClick: 0.024,
    status: 'activa',
    startDate: '10/05/2026',
    endDate: '10/06/2026',
  },
  {
    id: 5,
    radioName: 'Frecuencia Joven',
    radioFrequency: 'FM 94.1',
    radioCity: 'Medellín',
    radioPlan: 'Premium',
    promotionType: 'locutor',
    promotionName: 'DJ Max Rodríguez',
    country: 'Colombia',
    state: 'Antioquia',
    city: 'Medellín',
    category: 'Entretenimiento',
    impressions: 310000,
    clicks: 26350,
    ctr: 8.5,
    budget: 950,
    spend: 780,
    costPerClick: 0.03,
    status: 'activa',
    startDate: '15/05/2026',
    endDate: '15/07/2026',
  },
  {
    id: 6,
    radioName: 'Noticias 24/7',
    radioFrequency: 'AM 680',
    radioCity: 'Lima',
    radioPlan: 'Estándar',
    promotionType: 'radio',
    promotionName: 'Noticias 24/7 AM',
    country: 'Perú',
    state: 'Lima',
    city: 'Lima',
    category: 'Noticias',
    impressions: 420000,
    clicks: 28980,
    ctr: 6.9,
    budget: 1100,
    spend: 720,
    costPerClick: 0.025,
    status: 'activa',
    startDate: '01/06/2026',
    endDate: '01/08/2026',
  },
  {
    id: 7,
    radioName: 'Radio del Sol',
    radioFrequency: 'FM 99.9',
    radioCity: 'Santiago',
    radioPlan: 'Básico',
    promotionType: 'programa',
    promotionName: 'Tardes de Sol',
    country: 'Chile',
    state: 'RM',
    city: 'Santiago',
    category: 'Música',
    impressions: 95000,
    clicks: 5225,
    ctr: 5.5,
    budget: 400,
    spend: 180,
    costPerClick: 0.034,
    status: 'pausada',
    startDate: '20/05/2026',
    endDate: '20/06/2026',
  },
  {
    id: 8,
    radioName: 'Radio Tropical',
    radioFrequency: 'FM 91.7',
    radioCity: 'Bogotá',
    radioPlan: 'Estándar',
    promotionType: 'evento',
    promotionName: 'Noche Tropical 2026',
    country: 'Colombia',
    state: 'Cundinamarca',
    city: 'Bogotá',
    category: 'Eventos',
    impressions: 0,
    clicks: 0,
    ctr: 0,
    budget: 750,
    spend: 0,
    costPerClick: 0,
    status: 'pausada',
    startDate: '01/07/2026',
    endDate: '01/08/2026',
  },
  {
    id: 9,
    radioName: 'Radio Capital',
    radioFrequency: 'FM 96.8',
    radioCity: 'Buenos Aires',
    radioPlan: 'Premium',
    promotionType: 'concurso',
    promotionName: 'Adivina la Canción',
    country: 'Argentina',
    state: 'CABA',
    city: 'Buenos Aires',
    category: 'Música',
    impressions: 410000,
    clicks: 35670,
    ctr: 8.7,
    budget: 650,
    spend: 650,
    costPerClick: 0.018,
    status: 'finalizada',
    startDate: '01/03/2026',
    endDate: '30/04/2026',
  },
  {
    id: 10,
    radioName: 'Voz del Pueblo',
    radioFrequency: 'FM 104.5',
    radioCity: 'Buenos Aires',
    radioPlan: 'Premium',
    promotionType: 'locutor',
    promotionName: 'María Elena Contreras',
    country: 'Argentina',
    state: 'CABA',
    city: 'Buenos Aires',
    category: 'Entretenimiento',
    impressions: 0,
    clicks: 0,
    ctr: 0,
    budget: 900,
    spend: 0,
    costPerClick: 0,
    status: 'pausada',
    startDate: '01/08/2026',
    endDate: '01/10/2026',
  },
  {
    id: 11,
    radioName: 'Radio Mix FM',
    radioFrequency: 'FM 107.3',
    radioCity: 'Monterrey',
    radioPlan: 'Estándar',
    promotionType: 'radio',
    promotionName: 'Radio Mix FM',
    country: 'México',
    state: 'Nuevo León',
    city: 'Monterrey',
    category: 'Música',
    impressions: 158000,
    clicks: 11060,
    ctr: 7.0,
    budget: 550,
    spend: 380,
    costPerClick: 0.034,
    status: 'activa',
    startDate: '01/06/2026',
    endDate: '30/06/2026',
  },
  {
    id: 12,
    radioName: 'La Estación',
    radioFrequency: 'FM 100.1',
    radioCity: 'Rosario',
    radioPlan: 'Básico',
    promotionType: 'programa',
    promotionName: 'Mañanas de Radio',
    country: 'Argentina',
    state: 'Santa Fe',
    city: 'Rosario',
    category: 'Entretenimiento',
    impressions: 82000,
    clicks: 4756,
    ctr: 5.8,
    budget: 300,
    spend: 210,
    costPerClick: 0.044,
    status: 'activa',
    startDate: '10/06/2026',
    endDate: '10/07/2026',
  },
  {
    id: 13,
    radioName: 'Sinfónica FM',
    radioFrequency: 'FM 93.4',
    radioCity: 'Bogotá',
    radioPlan: 'Premium',
    promotionType: 'evento',
    promotionName: 'Concierto Sinfónico Anual',
    country: 'Colombia',
    state: 'Cundinamarca',
    city: 'Bogotá',
    category: 'Eventos',
    impressions: 0,
    clicks: 0,
    ctr: 0,
    budget: 1800,
    spend: 0,
    costPerClick: 0,
    status: 'pausada',
    startDate: '15/06/2026',
    endDate: '15/09/2026',
  },
  {
    id: 14,
    radioName: 'Noticias 24/7',
    radioFrequency: 'AM 680',
    radioCity: 'Lima',
    radioPlan: 'Estándar',
    promotionType: 'concurso',
    promotionName: 'Periodista del Mes',
    country: 'Perú',
    state: 'Lima',
    city: 'Lima',
    category: 'Noticias',
    impressions: 195000,
    clicks: 13065,
    ctr: 6.7,
    budget: 450,
    spend: 450,
    costPerClick: 0.034,
    status: 'finalizada',
    startDate: '01/02/2026',
    endDate: '31/03/2026',
  },
  {
    id: 15,
    radioName: 'Estación Latina',
    radioFrequency: 'FM 88.2',
    radioCity: 'Ciudad de México',
    radioPlan: 'Premium',
    promotionType: 'locutor',
    promotionName: 'Carlos "El Bueno" Vargas',
    country: 'México',
    state: 'CDMX',
    city: 'Ciudad de México',
    category: 'Entretenimiento',
    impressions: 520000,
    clicks: 47320,
    ctr: 9.1,
    budget: 1500,
    spend: 1320,
    costPerClick: 0.028,
    status: 'activa',
    startDate: '01/05/2026',
    endDate: '01/08/2026',
  },
  {
    id: 16,
    radioName: 'Radio Mix FM',
    radioFrequency: 'FM 107.3',
    radioCity: 'Monterrey',
    radioPlan: 'Estándar',
    promotionType: 'concurso',
    promotionName: 'Boleto de Oro Mix',
    country: 'México',
    state: 'Nuevo León',
    city: 'Monterrey',
    category: 'Música',
    impressions: 118000,
    clicks: 7670,
    ctr: 6.5,
    budget: 380,
    spend: 380,
    costPerClick: 0.05,
    status: 'finalizada',
    startDate: '01/04/2026',
    endDate: '15/05/2026',
  },
];